import type { TFunction } from "i18next";

/**
 * Shared title for every integration modal — "Lägg till <name> datakälla".
 * Centralizes the one i18n key that was otherwise repeated across ~20 modals.
 */
export const integrationModalTitle = (t: TFunction, name: string): string =>
	t("Add {{name}} data source", { name });
